import DrawerDivider from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DraweDivider/DrawerDivider';
import Drawer from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/Drawer/Drawer';
import DrawerItem from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerItem/DrawerItem';
import DrawerList from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerList/DrawerList';
import DrawerLogo from '@src/main/ui/components/layout/common/Navbar/NavbarDesktop/DrawerLogo/DrawerLogo';
import useNavbarItems, {
  NavbarItems,
} from '@src/main/ui/components/layout/common/Navbar/common/hooks/useNavbarItems';
import { FC } from 'react';

const NavbarDesktop: FC = () => {
  const navbarItems: NavbarItems | undefined = useNavbarItems();

  return (
    <Drawer width={90}>
      <DrawerList>
        <DrawerLogo />
        {navbarItems?.main.map((navbarItem) => (
          <DrawerItem key={navbarItem.text} {...navbarItem} />
        ))}
      </DrawerList>
      <DrawerDivider />
      <DrawerList>
        {navbarItems?.areas.map((navbarItem) => (
          <DrawerItem key={navbarItem.text} {...navbarItem} />
        ))}
      </DrawerList>
    </Drawer>
  );
};

export default NavbarDesktop;
